import { render } from "./SidenavList.vue?vue&type=template&id=02bdb698"
import script from "./SidenavList.vue?vue&type=script&lang=js"
export * from "./SidenavList.vue?vue&type=script&lang=js"
script.render = render

export default script